import React from 'react'
import { shortenLargeNumbers } from '../../utils/utils'

const formatIfNumber = (val) => (!isNaN(val) ? shortenLargeNumbers(val) : val)

/**
 * Curried custom tooltip.
 * @example:
 * const MyCustomTooltip = CustomTooltipWithLines({
 *   headingFormatter: (label, payload) => `${label} days ago`,
 *   valueFormatter: val => `${val}%`
 * });
 * // ...later inside the chart component //
 *   <Tooltip content={MyCustomTooltip} />
 *
 */
export const CustomTooltipWithLines = ({
  headingFormatter,
  valueFormatter,
  titleFormatter,
  shape = 'line',
  className,
  ...otherProps
}) => ({ type, payload, label, formatter, labelFormatter }) => {
  const shapes = ['line', 'rect']
  return (
    <div
      className={`CustomToolTipWithLines ${className || ''}`}
      {...otherProps}
    >
      <div className='heading'>
        {headingFormatter && typeof headingFormatter === 'function'
          ? headingFormatter(label, payload)
          : label}
      </div>
      <section className='content'>
        {!!payload &&
          payload.map((row, i) => {
            let displayVal =
              typeof valueFormatter === 'function'
                ? valueFormatter(row.value)
                : formatIfNumber(row.value)
            return (
              <div className={`row ${row.className || ''}`} key={i}>
                <span
                  className={`row-icon ${shape}`}
                  style={{ backgroundColor: row.color }}
                />
                <span className='row-title'>
                  {typeof titleFormatter === 'function'
                    ? titleFormatter(row.name)
                    : row.name}
                </span>
                <span className='row-value'>{displayVal || 0}</span>
              </div>
            )
          })}
      </section>
    </div>
  )
}

export default CustomTooltipWithLines
